import React, { useState } from 'react';
import { Paper, Button, Box, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { format } from 'date-fns';
import { CampaignStatus, CampaignType, MemberStatus } from '../../../../utils/enums'
import useApiManager from '../../../../utils/Api/apiManager';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationDialog from '../../../ConfirmationDialog/ConfirmationDialog';
import { useNavigate } from 'react-router-dom';
import CampaignsDialog from './CampaignsDialog';

const DeleteRow = ({ hover }) => (
    <Box sx={{ position: 'relative', width: '20px', height: '22px' }}>
        {hover && <DeleteIcon />}
    </Box>
);

const Campaigns = ({ data, fetchCampaigns, contactId }) => {
    const navigate = useNavigate();
    const { del } = useApiManager();
    const [hoveredRow, setHoveredRow] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openCampaignsDialog, setOpenCampaignsDialog] = useState(false);
    const [currentRow, setCurrentRow] = useState('');

    const handleCampaignsOpenDialog = () => {
        setOpenCampaignsDialog(true);
    };

    const handleCampaignsCloseDialog = () => {
        setOpenCampaignsDialog(false);
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmAction = () => {
        handleDelete();
        handleCloseDialog();
    };

    const handleDelete = async () => {
        try {
            const deletedRow = await del(`/leadcampaigns/${contactId}/${currentRow.campaignId}`);
            fetchCampaigns();
        } catch (error) {
            console.error('Error unassigning:', error);
        }
    };

    const handleAddCampaigns = () => {
        handleCampaignsOpenDialog();
    };

    return (
        <div>
            <Paper elevation={0} sx={{ p: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <h4>Campaigns</h4>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button variant="contained" onClick={handleAddCampaigns}>Add Campaigns</Button>
                    </Box>
                </Box>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell width={10}>-</TableCell>
                                <TableCell width={100}>Campaign Name</TableCell>
                                <TableCell align="right">Status</TableCell>
                                <TableCell align="right">Type</TableCell>
                                <TableCell align="right">Start Date</TableCell>
                                <TableCell align="right">End Date</TableCell>
                                <TableCell align="right">Expected Revenue</TableCell>
                                <TableCell align="right">Budgeted Cost</TableCell>
                                <TableCell align="right">Member Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.map((row) => (
                                <TableRow
                                    key={row.campaignId}
                                    onMouseEnter={() => setHoveredRow(row.campaignId)}
                                    onMouseLeave={() => setHoveredRow(null)}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <Tooltip title="Delete">
                                        <TableCell sx={{ width: '20px', height: '22px', padding: '8px', cursor: 'pointer' }}
                                            onClick={() => {
                                                setCurrentRow(row);
                                                handleOpenDialog();
                                            }}>
                                            <DeleteRow hover={hoveredRow === row.campaignId} />
                                        </TableCell>
                                    </Tooltip>
                                    <TableCell component="th" scope="row">
                                        <Link to={`/campaigns/${row.campaignId}`}>{row.campaignName || 'No name'}</Link>
                                    </TableCell>
                                    <TableCell align="right">{CampaignStatus?.[row.campaignStatus]?.label || 'Unknown Status'}</TableCell>
                                    <TableCell align="right">{CampaignType?.[row.campaignType]?.label || 'Unknown type'}</TableCell>
                                    <TableCell align="right">
                                        {row.startDate ? format(new Date(row.startDate), 'MMMM do yyyy') : 'No start date'}
                                        </TableCell>
                                    <TableCell align="right">
                                        {row.endDate ? format(new Date(row.endDate), 'MMMM do yyyy') : 'No end date'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.expectedRevenue}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.budgetedCost}
                                    </TableCell>
                                    <TableCell align="right">{MemberStatus?.[row.memberStatus]?.label || 'Unknown Status'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <ConfirmationDialog
                    open={openDialog}
                    title="Confirm Action"
                    content="Are you sure you want to unassign this campaign?"
                    onClose={handleCloseDialog}
                    onConfirm={handleConfirmAction}
                    confirmText="Confirm"
                    cancelText="Cancel"
                />
            </Paper>

            <CampaignsDialog open={openCampaignsDialog} setOpen={setOpenCampaignsDialog} contactId={contactId} fetchCampaigns={fetchCampaigns}/>
        </div>
    );
};

export default Campaigns;
